<template>
  <v-menu
    :close-on-content-click="false"
    :nudge-width="200"
    v-model="menu"
    min-width="300px"
    class="menu-color-picker"
    >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-bind="attrs"
        outlined
        :autocomplete="false"
        append
        v-model="colorPicked"
        label="Brand Color"
        @focus="menu = !menu"
        :error-messages="errorMessages"
        v-on="on">
      </v-text-field>
    </template>

    <v-card>
      <v-color-picker
        show-swatches
        :value="colorPicked"
        @input="colorPickedChanged"
        mode="hexa">
      </v-color-picker>
      <v-card-actions class="py-3">
        <v-spacer></v-spacer>
        <v-btn color="primary" text class="text-transform-none" @click="menu = !menu">
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-transform-none" @click="selectColor">
          Select
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  props: ['value', 'errorMessages'],
  data () {
    return {
      menu: false,
      colorPicked: '#FFFFFF',
      temporaryPickedColor: null
    }
  },
  watch: {
    colorPicked (value) {
      this.$emit('input', value)
    }
  },
  methods: {
    colorPickedChanged (val) {
      this.temporaryPickedColor = val.hexa || val
    },
    selectColor () {
      this.colorPicked = this.temporaryPickedColor
      this.menu = false
    }
  }
}
</script>
